import { useCallback, useEffect, useMemo, useState } from 'react';

const normalizePayload = (values = {}) => ({
  nombre: (values.nombre || '').trim(),
  descripcion: (values.descripcion || '').trim(),
  icono: (values.icono || 'wrench').trim() || 'wrench',
  activo: Boolean(values.activo)
});

export const useAdminMotivos = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const fetchList = useCallback(async (signal) => {
    setLoading(true);
    setError(null);
    try {
      const response = await fetch('/admin/api/motivos-ajuste', { signal });
      const data = await response.json();
      if (!response.ok || data?.error) {
        throw new Error(data?.error || 'No se pudieron obtener los motivos');
      }
      if (!signal?.aborted) {
        setItems(data.motivos || []);
      }
    } catch (err) {
      if (!signal?.aborted) {
        setError(err?.message || 'Error al cargar motivos');
      }
    } finally {
      if (!signal?.aborted) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchList(controller.signal);
    return () => controller.abort();
  }, [fetchList, refreshToken]);

  const refresh = useCallback(() => {
    setRefreshToken((value) => value + 1);
  }, []);

  const saveMotivo = useCallback(async (values) => {
    const payload = normalizePayload(values);
    const hasId = Boolean(values?.id);
    const url = hasId ? `/admin/api/motivos-ajuste/${values.id}` : '/admin/api/motivos-ajuste';
    const method = hasId ? 'PUT' : 'POST';
    const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok || data?.error) {
      throw new Error(data?.error || 'No se pudo guardar el motivo');
    }
    return data;
  }, []);

  const deleteMotivo = useCallback(async (id) => {
    const response = await fetch(`/admin/api/motivos-ajuste/${id}`, { method: 'DELETE' });
    const data = await response.json();
    if (!response.ok || data?.error) {
      throw new Error(data?.error || 'No se pudo eliminar el motivo');
    }
    return data;
  }, []);

  return useMemo(() => ({
    items,
    loading,
    error,
    refresh,
    saveMotivo,
    deleteMotivo
  }), [items, loading, error, refresh, saveMotivo, deleteMotivo]);
};
